import { defineStore } from "pinia"
import { useOnlineStore, useUserStore } from "./index"
import { isClient } from "~/utils/isclient"

export const baseUseEpciCommuneStore = defineStore("epciCommuneStore", {
    // === STATE ===
    state: () => ({
        epciCommunes: [],
        currentEpciCommune: { id: null, name: null, v: null, mission_id: null, accessible_communes: [] },
        loading: false,
        error: null,
    }),

    // === ACTIONS ===
    actions: {
        initCurrentEpciCommune() {
            if (useUserStore().currentUser && useUserStore().currentUser.epci_commune) {
                this.setSelectedEpciCommune(useUserStore().currentUser.epci_commune)
            }
            // Ensure localStorage is accessed only on the client
            if (isClient()) {
                const savedCommune = localStorage.getItem("currentEpciCommune")
                if (savedCommune) {
                    try {
                        this.currentEpciCommune = JSON.parse(savedCommune) // Parse the saved object
                    }
                    catch (err) {
                        console.error("Failed to parse currentEpciCommune from localStorage:", err)
                        this.currentEpciCommune = { id: null, name: null, v: null, mission_id: null, accessible_communes: [] }
                    }
                }
                else {
                    this.currentEpciCommune = { id: null, name: null, v: null, mission_id: null, accessible_communes: [] }
                }
            }
            else {
                this.currentEpciCommune = { id: null, name: null, v: null, mission_id: null, accessible_communes: [] }
            }
        },

        async fetchEpciCommunes() {
            if (!useUserStore().currentUser || !useUserStore().currentUser.k) {
                return
            }
            const { $api } = useNuxtApp()
            this.loading = true // Set loading state to true
            this.error = null // Clear previous errors
            if (useOnlineStore().online) {
                try {
                    const route = {
                        url: "epci-communes/missions",
                        method: "GET",
                        pagination: { number: 1, size: 200 },
                    }
                    const response = await $api.getListData(route) // Call ApiService to fetch data
                    this.epciCommunes = response.data || response // Ensure response has data
                    if (isClient()) {
                        localStorage.setItem("communesWithMissions", JSON.stringify(this.epciCommunes))
                        const freshCurrent = this.epciCommunes.find(com => com?.id === this.currentEpciCommune?.id)
                        if (freshCurrent) {
                            this.setSelectedEpciCommune(freshCurrent)
                        }
                        else if (this.currentEpciCommune?.id) {
                            this.setSelectedEpciCommune(null)
                        }
                    }
                }
                catch (err) {
                    this.error = "Failed to load EPCI communes" // Store the error
                    console.error(err) // Log the error
                    this.setSelectedEpciCommune(null)
                }
                finally {
                    this.loading = false // Set loading state to false
                }
            }
            else if (isClient() && localStorage.getItem("communesWithMissions")) {
                this.epciCommunes = JSON.parse(localStorage.getItem("communesWithMissions"))
                this.loading = false
            }
        },

        setSelectedEpciCommune(commune) {
            if (commune) {
                this.currentEpciCommune = commune // Update the selected EPCI commune
            }
            else {
                this.currentEpciCommune = { id: null, name: null, v: null, mission_id: null, accessible_communes: [] }
            }
            // Save to localStorage (client-side only)
            if (isClient()) {
                try {
                    localStorage.setItem("currentEpciCommune", JSON.stringify(commune))
                }
                catch (err) {
                    console.error("Failed to save currentEpciCommune to localStorage:", err)
                }
            }
        },
    },
})
